import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  padding: 8px;
  z-index: 9999;

  main {
    background: #fff;
    /* padding: 0 8px; */
    width: 100%;
    height: 100%;
    border-radius: 6px;
    position: relative;
  }
`;
